import { VersionResolutionError } from "@/lib/game-system";
import { AsyncOp, InaccessibleDatabaseError, Pending, QueryError } from "@indietabletop/appkit";
import { createContext, useContext } from "react";
import { UserSettings } from "../../lib/user-settings";

export const UserSettingsContext = createContext<
  AsyncOp<UserSettings, QueryError | InaccessibleDatabaseError | VersionResolutionError>
>(new Pending());

export function useUserSettingsOp() {
  return useContext(UserSettingsContext);
}
